export enum NuxtRoutes {
  // Root
  Agenten = 'Agenten',
  Anrufe = 'Anrufe',
  Dashboard = 'Dashboard',
  DeineAnfragen = 'DeineAnfragen',
  Home = 'Home',
  Index = 'Index',
  Secret = 'Secret',
  Unsubscribe = 'Unsubscribe',
  // Outbound Campaigns (MVP A)
  Kampagnen = 'Kampagnen',
  KampagnenErstellen = 'KampagnenErstellen',
  KampagneDetail = 'KampagneDetail',
  // Admin
  AdminBenutzer = 'AdminBenutzer',
  AdminKundenbereich = 'AdminKundenbereich',
  // Auth
  AuthLogin = 'AuthLogin',
  AuthSignup = 'AuthSignup',
  AuthMfaChallenge = 'AuthMfaChallenge',
  AuthMfaSetup = 'AuthMfaSetup',
  AuthForgotPassword = 'AuthForgotPassword',
  AuthCustomActionRouter = 'AuthCustomActionRouter',
  AuthForgotPasswordAction = 'AuthForgotPasswordAction',
  // Settings
  SettingsAbrechnung = 'SettingsAbrechnung',
  SettingsMeineDaten = 'SettingsMeineDaten',
  SettingsMitarbeiterVerwalten = 'SettingsMitarbeiterVerwalten',
  SettingsRechtlicheAngaben = 'SettingsRechtlicheAngaben',
  SettingsTagsVerwalten = 'SettingsTagsVerwalten',
  SettingsCrmFiles = 'SettingsCrmFiles',
  SettingsCustomerSettings = 'SettingsCustomerSettings',
  SettingsEmailTemplates = 'SettingsEmailTemplates',
  SettingsPartnerSettings = 'SettingsPartnerSettings',
  SettingsTelefonie = 'SettingsTelefonie',
  SettingsIntegrationen = 'SettingsIntegrationen',
  SettingsIntegrationenVerbindungen = 'SettingsIntegrationenVerbindungen',
  SettingsIntegrationenVerbindungenHinzufuegen = 'SettingsIntegrationenVerbindungenHinzufuegen',
  SettingsIntegrationenModule = 'SettingsIntegrationenModule',
  SettingsIntegrationenModuleKalender = 'SettingsIntegrationenModuleKalender',
  // Dynamic Agent Routes
  AgentIntentView = 'AgentIntentView',
  AgentPersoenlichkeitView = 'AgentPersoenlichkeitView',
  // AgentIntentChange = "AgentIntentChange",
  AgentPersoenlichkeitChange = 'AgentPersoenlichkeitChange',
  AgentVerfuegbarkeitView = 'AgentVerfuegbarkeitView',
}
